import api from './client';

export const stockAdjustmentApi = {
  list:     (params?: any) => api.get('/stock-adjustments', { params }),
  getStock: (params?: any) => api.get('/stock-adjustments/stock', { params }),
  create:   (data: any)    => api.post('/stock-adjustments', data),
};
